import { useWindowSize } from 'react-use';
import { useDispatch, useSelector } from 'react-redux';
import { fetchProductImage, setSingle } from '../products/productsSlice';
import { CardMobile } from './card-mobile';
import { CardDesktop } from './card-desktop';
import { QuantitySelector } from '../../cart/quantity-selector';
import { Add } from '../../cart/add';
import { Like } from './like';
import { useEffect, useRef } from 'react';
import { motion, useInView } from 'framer-motion';

import './products-card.css';

export const ProductCard = ({ rest }) => {
    const image = useSelector(state => state.products.productsImage[rest?.id]);
    const imageLoadingStatus = useSelector(state => state.products.productImageLoadingStatus[rest?.id]);
    const { width } = useWindowSize();
    const cart = useSelector(state => state.cart.cart);
    const dispatch = useDispatch();
    const ref = useRef(null);
    const inView = useInView(ref, { triggerOnce: true }); 

    useEffect(() => {
        if (inView && imageLoadingStatus !== 'idle') {
            dispatch(fetchProductImage({ id: rest?.id }));
        }
    }, [inView, imageLoadingStatus, dispatch, rest?.id]);

    const btns = cart.some(item => item.id === rest.id) 
        ? <QuantitySelector id={rest.id} />
        : <Add rest={rest} />;

    return (
        <motion.div
            ref={ref}
            initial={{ opacity: 0, x: -50 }}
            animate={{ opacity: 1, x: 0 }} 
            transition={{ duration: 0.3 }}
            onClick={() => dispatch(setSingle(rest.id))}
            className="col-12 mb-md-4 col-md-6 col-lg-3"
        >
            {width < 768 ?
                <CardMobile img={image} rest={rest}>
                    <Like rest={{ id: rest.id, likes: rest.likes }} />
                    {btns}
                </CardMobile>
                :
                <CardDesktop img={image} rest={rest}>
                    <Like rest={{ id: rest.id, likes: rest.likes }} />
                    {btns}
                </CardDesktop>
            }
        </motion.div>
    );
}
